import tipTopupVue from './index.vue'
// 定义插件对象
let TipPopup = {}

// vue的install方法，用于定于vue插件
TipPopup.install = function (Vue, options) {
  let currentMsg
  const TipPopupInstance = Vue.extend(tipTopupVue)

  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new TipPopupInstance()
    TipPopup = currentMsg
    TipPopup.currentMsg = currentMsg
    let msgBoxEl = currentMsg.$mount().$el
    document.body.appendChild(msgBoxEl)
  }
  Vue.prototype.$tipPopup =
    function (options) {
      if (!currentMsg) {
        initInstance()
      }
      if (typeof options === 'string') {
        currentMsg.content = options
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options)
      }
      return currentMsg.showMsgBox().then(val => {
        currentMsg = null
        // TipPopup.currentMsg.closeMsgBox()
        return Promise.resolve(val)
      })
        .catch(err => {
          currentMsg = null
          return Promise.reject(err)
        })
    }
}
export default TipPopup
